import { DropdownItemPGAForm } from "helpers/types/pgaTypes";

export const NORTHERN_IRELAND = "Northern Ireland";

export const OTHER = "Other";

export const listBooleanPGAForm = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];

export const listBooleanDropDownPGAForm: DropdownItemPGAForm[] = [
  { label: "Yes", value: 1 },
  { label: "No", value: 0 },
];

export const TABLE_ERROR_TYPE = {
  ALL: "all",
  ROW: "row",
  CELL: "cell",
  NONE: "none",
};

export const StatusPGAForm = {
  NotStarted: "NotStarted",
  DRAFT: "Draft",
  SUBMITTED: "Submitted",
  COMPLETED: "Approved",
};

export const valueNoDropdown = listBooleanPGAForm[1];

export const pgaEmptyArrayErrorType = ["required", "optionality"]; 
